/**
 * Created by Ivan on 27.07.2026
 */

const EnergyBooster = function () {
    this.load();
    this.scheduleExpire();
};

EnergyBooster.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.ENERGY_BOOSTER) || {};
    this.finishTime = data.finishTime || 0;
};

EnergyBooster.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.ENERGY_BOOSTER, {
        finishTime: this.finishTime
    });
};

EnergyBooster.prototype.getLeftTime = function () {
    return Math.max(0, this.finishTime - Date.now());
};

EnergyBooster.prototype.isActive = function () {
    return this.getLeftTime() > 0;
};

EnergyBooster.prototype.getOrderEnergy = function (ingredients) {
    const totalScore = ingredients.reduce((totalScore, ingredient) => {
        const weight = EnergyBooster.WEIGHTS_BY_LINE[ingredient.unit.code] || 10;
        const score = weight * 2 ** ingredient.unit.stage * ingredient.amount;

        return totalScore + score;
    }, 0);

    let energy = 0;
    for (const threshold in EnergyBooster.ENERGY_BY_BRACKET) {
        if (totalScore >= threshold) {
            energy = EnergyBooster.ENERGY_BY_BRACKET[threshold];
        } else {
            break;
        }
    }

    return energy;
};

EnergyBooster.prototype.activate = function (time) {
    if (typeof time === "string") {
        time = cleverapps.parseInterval(time);
    }

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_USE}-energy`, { value: Math.round(time / cleverapps.parseInterval("1 minute")) });
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_USE_DAU}-energy`);

    this.finishTime = Math.max(this.finishTime, Date.now()) + time;
    this.save();

    this.scheduleExpire();
    this.refreshIcon();
    this.updateOrderRewards();
};

EnergyBooster.prototype.scheduleExpire = function () {
    if (this.expireTimeout) {
        this.expireTimeout.remove();
        this.expireTimeout = undefined;
    }

    if (this.isActive()) {
        this.expireTimeout = new cleverapps.LongTimeout(this.onExpired.bind(this), this.getLeftTime());
    }
};

EnergyBooster.prototype.onExpired = function () {
    this.expireTimeout = undefined;

    cleverapps.extraBar.removeIcon(EnergyBoosterExtraBarIcon);
    this.updateOrderRewards();
};

EnergyBooster.prototype.refreshIcon = function () {
    cleverapps.extraBar.removeIcon(EnergyBoosterExtraBarIcon, true);
    cleverapps.extraBar.addIcon(EnergyBoosterExtraBarIcon);
};

EnergyBooster.prototype.updateOrderRewards = function () {
    if (Merge2.current) {
        cleverapps.eventBus.trigger("merge2CustomersForceUpdateReward");
    }
};

EnergyBooster.ENERGY_BY_BRACKET = {
    0: 3,
    411: 5,
    1101: 10,
    3501: 25
};

EnergyBooster.WEIGHTS_BY_LINE = {
    a: 10,
    b: 40,
    c: 11,
    d: 50,
    e: 30,
    f: 25,
    g: 22,
    h: 60,
    i: 11
};

// EnergyBooster.ORDER_ENERGY = 5;

const EnergyBoosterExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.questsgroupicon.jsons.energy_booster_icon_prefab_json);
    },
    extraBarWeight: 100002
};
